import React, {FC} from 'react';
import {Link} from 'react-router-dom';
import {History} from 'history';
import {HEADER} from '@optimaxdev/analytics/mobile';

import {Icon} from 'components/baseIcon/baseIcon';
import * as CheckIcon from 'components/__helpers/icon/svg/common/check.svg';
import {sendAnalytics} from 'libs/analytics/sendAnalytics';

import {QuickStartGuideContent} from './components/quickStartGuideContent';
import {PageWrapper} from '../';
import s from './quickStartGuide.scss';

type LinkPropsType = {
    children: string;
    linkHref: string;
    clickHandler: (linkText: string) => void;
};
const LinkWithAnalytics: FC<LinkPropsType> = ({children, linkHref, clickHandler}) => {
    return (
        <Link to={linkHref} className={s.footerLink} onClick={() => clickHandler(children)}>
            {children}
        </Link>
    );
};

const FooterRows = React.memo(() => {
    const FOOTER_ROWS = [
        '“No questions asked” return policy',
        '100% Money Back Guarantee',
        'Free Shipping',
    ];

    return (
        <>
            {FOOTER_ROWS.map(rowText => (
                <div className={s.subFooterTxt} key={rowText}>
                    <Icon icon={CheckIcon} />
                    <span>{rowText}</span>
                </div>
            ))}
        </>
    );
});

type PropsType = {
    history: History;
};

/**
 * Quick Start Guide page
 * @returns {React.ReactElement} - start guide page
 */
export const QuickStartGuide: FC<PropsType> = ({history}) => {
    const clickHandler = (label: string) => {
        sendAnalytics(HEADER.START_GUIDE, {label});
    };

    const closePage = () => {
        clickHandler('Close');
        history.goBack();
    };

    return (
        <PageWrapper pageType="default" headerComponent={null}>
            <button type="button" aria-label="Close" className={s.close} onClick={closePage} />
            <div className={s.quickStarGuideContent}>
                <QuickStartGuideContent clickHandler={clickHandler} />
                <div className={s.footer}>
                    <p className={s.footerLm}>Learn More:</p>
                    <div className={s.footerBtn}>
                        <LinkWithAnalytics
                            linkHref="/how-to?tabindex=3"
                            clickHandler={clickHandler}
                        >
                            How To Measure Your PD
                        </LinkWithAnalytics>
                    </div>
                    <div className={s.footerSec}>
                        <div className={s.footerBtn}>
                            <LinkWithAnalytics linkHref="/how-to" clickHandler={clickHandler}>
                                More How-to Videos
                            </LinkWithAnalytics>
                        </div>
                        <div className={s.footerBtn}>
                            <LinkWithAnalytics linkHref="/faq" clickHandler={clickHandler}>
                                FAQ
                            </LinkWithAnalytics>
                        </div>
                    </div>
                </div>
                <div className={s.subFooter}>
                    <p className={s.footerTxtSub}>The Smart Way to Buy Glasses:</p>
                    <FooterRows />
                </div>
                <button type="button" className={s.btnClose} onClick={closePage}>
                    Close <span>✕</span>
                </button>
            </div>
        </PageWrapper>
    );
};

export default QuickStartGuide;
